export function DottedLoader({ size = "md", className = "" }) {
  const dotSize =
    size === "sm" ? "h-1.5 w-1.5" : size === "lg" ? "h-2.5 w-2.5" : "h-2 w-2";
  const gap = size === "sm" ? "gap-1.5" : size === "lg" ? "gap-2.5" : "gap-2";
  const shellPadding =
    size === "sm" ? "px-2.5 py-1.5" : size === "lg" ? "px-3.5 py-2" : "px-3 py-1.5";

  return (
    <div
      className={`inline-flex items-center rounded-full border border-slate-200/90 bg-white/95 ${shellPadding} ${className}`.trim()}
      aria-hidden="true"
    >
      <style>{`
        @keyframes vbotDotWave {
          0%, 80%, 100% {
            transform: translateY(0);
            opacity: 0.35;
          }
          40% {
            transform: translateY(-3px);
            opacity: 1;
          }
        }
      `}</style>
      <div className={`flex items-center ${gap}`}>
        {[0, 1, 2].map((idx) => (
          <span
            key={idx}
            className={`${dotSize} rounded-full bg-slate-500/85`}
            style={{
              animation: "vbotDotWave 1.05s ease-in-out infinite",
              animationDelay: `${idx * 140}ms`,
            }}
          />
        ))}
      </div>
    </div>
  );
}

export function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center p-8">
      <DottedLoader size="lg" />
    </div>
  );
}
  